import { render, staticRenderFns } from "./InformationText.vue?vue&type=template&id=8d1c9004&"
import script from "./InformationText.vue?vue&type=script&lang=ts&"
export * from "./InformationText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports